import { render, staticRenderFns } from "./TransactionChargesModal.vue?vue&type=template&id=d87590ce&scoped=true"
import script from "./TransactionChargesModal.vue?vue&type=script&lang=js"
export * from "./TransactionChargesModal.vue?vue&type=script&lang=js"
import style0 from "./TransactionChargesModal.vue?vue&type=style&index=0&id=d87590ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87590ce",
  null
  
)

export default component.exports